import {PERMISSION_TYPE} from '../../../Permissions';
import {hasSomePermission} from '../../../forecast-app/shared/util/PermissionsUtil';
import Util from "../../../forecast-app/shared/util/util";

export const theEyeOptionsNoGrouping = [
	{
		name: 'project',
		checked: true,
		translationId: null,
		hide: true,
	},
	{
		name: 'task',
		checked: true,
		translationId: null,
		hide: true,
	},
	{
		name: 'reportedTime',
		checked: true,
		translationId: 'common.reported',
		nestedOptions: null,
		hide: true,
	},
	{
		name: 'notes',
		checked: false,
		translationId: 'common.notes',
		nestedOptions: null,
	},
	{
		name: 'date',
		checked: true,
		translationId: 'common.date',
		nestedOptions: null,
	},
	{
		name: 'personIcon',
		checked: true,
		translationId: 'common.person',
		hide: true,
	},
	{
		name: 'roleName',
		checked: true,
		translationId: 'common.role',
		nestedOptions: null,
	},
	{
		name: 'clientName',
		checked: true,
		translationId: 'common.client',
		nestedOptions: null,
	},
	{
		name: 'billable',
		checked: false,
		translationId: 'common.billable',
		nestedOptions: null,
	},
	{
		name: 'price',
		checked: false,
		translationId: 'project_budget.actual_revenue',
		nestedOptions: null,
	},
	{
		name: 'cost',
		checked: false,
		translationId: 'insights.component.list.column.actualCost',
		nestedOptions: null,
	},
	{
		name: 'invoiced',
		checked: false,
		translationId: 'project_budget.invoiced',
		nestedOptions: null,
	},
	{
		name: 'approvalStatus',
		checked: false,
		translationId: 'common.approved',
		nestedOptions: null,
	},
];

export const theEyeOptionsByGrouping = (initialEyeOptions, firstGrouping) => {
	let currentEyeOptions = [...initialEyeOptions];
	if (firstGrouping !== null) {
		currentEyeOptions.unshift(
			{
				name: 'caretIcon',
				checked: true,
				translationId: null,
				hide: true,
			},
			{
				name: 'mainItem',
				checked: true,
				translationId: null,
				hide: true,
			}
		);
	}
	return currentEyeOptions;
};

export const filterObjectEyeOptions = initialEyeOptions => {
	const financialFields = ['price', 'cost'];
	const filteredEyeOptions = {...initialEyeOptions};
	const hasFinancialAccess = hasSomePermission([PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION, PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE]);
	const hasLimitedFinancialAccess = Util.hasLimitedFinancialAccess();
	if (!hasFinancialAccess) {
		financialFields.forEach(field => {
			delete filteredEyeOptions[field];
		});
	}
	if(hasLimitedFinancialAccess){
		delete filteredEyeOptions['cost'];
	}
	return filteredEyeOptions;
};
export const theEyeOptionsFiltered = initialEyeOptions => {
	const financialFields = ['price', 'cost'];
	const hasFinancialAccess = hasSomePermission([PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION, PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE]);
	const hasLimitedFinancialAccess = Util.hasLimitedFinancialAccess();
	const financialFieldFilter = item => {
		if (!hasFinancialAccess) {
			return !financialFields.includes(item.name);
		}
		if(hasLimitedFinancialAccess){
			return item.name !== 'cost';
		}
		return true;
	};

	const currentEyeOptions = [...initialEyeOptions];
	return currentEyeOptions.filter(financialFieldFilter);
};
